export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="font-heading text-xl font-black text-white tracking-tight">网红黑料</span>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                每日汇总网红黑料情报，实时更新最新爆料，一站吃尽网红圈黑料。专注为吃瓜群众提供最快、最全、最真实的网红黑料信息。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { href: '#ranking', label: '热度榜单' },
                  { href: '#carousel', label: '焦点专题' },
                  { href: '#cards', label: '最新爆料' },
                  { href: '#updates', label: '实时快讯' },
                ].map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">特色栏目</h4>
              <ul className="space-y-2.5">
                {[
                  { href: '#features', label: '特色优势' },
                  { href: '#comments', label: '吃瓜热评' },
                  { href: '#faq', label: '常见问答' },
                  { href: '#topics', label: '热门话题' },
                ].map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                {[
                  { href: '#contact', label: '投稿爆料' },
                  { href: '#about', label: '关于我们' },
                  { href: '#index', label: '专题索引' },
                  { href: '#app', label: '手机访问' },
                ].map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800/60">
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-foreground-400 mb-3">合作伙伴</h4>
              <p className="text-xs text-foreground-500">虚位以待，诚邀优质平台合作</p>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 网红黑料. 本站内容仅供信息参考，不构成任何建议。请理性吃瓜，文明上网。
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-500">关注我们</span>
                <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="RSS">
                  <i className="ri-rss-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}